import { useState } from "react";
import { Show } from "../../../../hooks/Show";
import { CreatePackagingModal } from "../../../../components/Modal/WMS/Packaging/CreatePackagingModal";

export const HeaderPackaging = () => {
  const [openModalCreatePackaging, setOpenModalCreatePackaging] =
    useState(false);

  return (
    <>
      <div className="d-sm-flex align-items-center mb-1 align-items-center">
        <h1 className="h3 mb-0 text-gray-800 mr-3">Embalajes</h1>
        <Show when="feature:wms-packaging-create">
          <button
            className="btn btn-primary btn-circle"
            type="button"
            onClick={() => setOpenModalCreatePackaging(true)}
            title="Crear Embalaje"
          >
            <i className="fas fa-plus fa-sm"></i>
          </button>
        </Show>
      </div>
      <p className="mb-4">Módulo de Administración de Embalajes</p>
      <CreatePackagingModal
        show={openModalCreatePackaging}
        handleClose={() => setOpenModalCreatePackaging(false)}
      />
    </>
  );
};
